import { z } from 'zod';
import { ShadowSettingKeySchema } from '../setting/shadow-setting';
import { BasicAnimationSetSchema } from './animations';
import { BasePinComponentSchema, BasePinComponentSettingsSchema } from './base-pin-component';

export const MarkerTypeSchema = z.enum(['NONE', 'ARROW']);
export type MarkerType = z.infer<typeof MarkerTypeSchema>;

export const isMarkerType = (markerType: string): markerType is MarkerType => {
  return markerType === 'NONE' || markerType === 'ARROW';
};

export const LinePinComponentPinThemeSettingsSchema = z.object({
  shadow: ShadowSettingKeySchema,
  fillColor: z.string().optional(),
});
export type LinePinComponentPinThemeSettings = z.infer<typeof LinePinComponentPinThemeSettingsSchema>;

const LineSettingsSchema = BasePinComponentSettingsSchema.extend(
  LinePinComponentPinThemeSettingsSchema.extend(
    z.object({
      headMarker: MarkerTypeSchema.optional(),
      tailMarker: MarkerTypeSchema.optional(),
      width: z.number().gt(0).optional(),
      animations: BasicAnimationSetSchema.optional(),
    }).shape
  ).shape
);
export type LineSettings = z.infer<typeof LineSettingsSchema>;

export const LinePinComponentTypeSchema = z.literal('LINE');

export const LinePinComponentSchema = BasePinComponentSchema.extend(
  z.object({
    type: LinePinComponentTypeSchema,
    settings: LineSettingsSchema,
    position: z.any().optional(),
  }).shape
);
